import {Injectable, inject} from '@angular/core'
import type {AnalyticsProvider} from './analytics-provider.interface'
import {environment} from '@cart/src/environments/environment'
import {InfoService} from '../info.service'
import {LogType, Logger} from '../utils/logger'

declare let gtag: (property: string, value: any, configs?: any) => void

@Injectable({providedIn: 'root'})
export class GoogleAnalyticsProvider implements AnalyticsProvider {
  readonly #infoService = inject(InfoService)

  async init(): Promise<void> {
    // GA script is injected in AppComponent.injectGAScripts()
  }

  isEnabled(): boolean {
    return environment.analytics && this.#infoService.isWeb() && !!environment.googleAnalyticsId
  }

  trackEvent(name: string, properties?: Record<string, unknown>): void {
    if (!this.isEnabled()) {
      return
    }
    Logger.log(LogType.debug, '[GoogleAnalytics] trackEvent', name, properties)
    gtag('event', name, properties)
  }

  identifyUser(userId: string, properties?: Record<string, unknown>): void {
    if (!this.isEnabled()) {
      return
    }
    Logger.log(LogType.debug, '[GoogleAnalytics] identifyUser', userId, properties)
    gtag('config', environment.googleAnalyticsId, {user_id: userId})
    gtag('set', 'user_properties', {user_id: userId, crm_id: userId, ...properties})
  }

  resetUser(): void {
    // GA4 does not support resetting user identity
  }

  setScreen(_name: string): void {
    // GA4 on web tracks page views automatically via gtag config
  }
}
